module.exports = {
      id: "breaking-news-usage",
      viewBox: "0 0 25 25",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#breaking-news",
      toString: function () {
        return this.url;
      }
    }